module.exports = __webpack_public_path__ + "img/ser_title.0651e0dd.png";